import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { Translation } from "react-i18next";

import DetailsService from "../../services/screens/admin/unit/DetailsService";
import MessageBox from "./MessageBox";
import * as Helper from "../../utils/Helper";
import UnitView from "../units/UnitView";
import UnitTopAudioPlayer from "./UnitTopAudioPlayer";
import UIDs from "../../UIDs";

const uid = UIDs.components.ui.generalArticle;
/**
 * Created by JIA on 2023/8/18.
 */
export default function GeneralArticle(props) {
    const { data, t, cover, localVars } = props;
    const { article, title } = data;
    let { audioPath, imagePath, useCover, textSource } = article || {};
    if (useCover) {
        imagePath = cover;
    }

    let articleUnitId = "";
    if (textSource && textSource.type && (textSource.type === "1" || textSource.type === "3")) {
        if (textSource.path && textSource.path.split(",").length === 3) {
            articleUnitId = textSource.path.split(",")[2];
        }
    }

    const [modal, setModal] = useState(false);
    const [state_unitDetails, setstate_unitDetails] = useState(null);

    const toggle = () => {
        setModal(!modal);
        if (!modal) {
            if (!state_unitDetails) {
                getUnitDetails(getUnitDetailsSuccessCallback);
            }
        }
    };

    const getUnitDetails = (getUnitDetailsSuccessCallback) => {
        DetailsService.loadScreenView(
            articleUnitId,
            (response) => {
                getUnitDetailsSuccessCallback(response);
            },
            (error) => {
                MessageBox.danger({ text: error.message, duration: 5000 });
            }
        );
    };

    const getUnitDetailsSuccessCallback = (data) => {
        setstate_unitDetails(data.unitDetails);
    };

    return (
        <>
            {props.showTitle && title ? <div style={{ fontSize: `${localVars.styleList.defFontSize / 1.2}px`, color: "#B1B1B1", margin: "10px auto" }}>{title && Helper.localizeString(title)}</div> : null}
            {articleUnitId ? (
                <div>
                    <div style={{ textAlign: "center" }}>
                        <Button color="primary" onClick={toggle} size="sm">
                            <Translation ns={uid}>{(t) => t("details")}</Translation>
                        </Button>
                    </div>
                    <Modal isOpen={modal}>
                        <ModalHeader className="aic-modal-header" style={{ padding: "10px 10px 5px", height: "40px" }} toggle={toggle} charCode="X">
                            <h3>
                                <Translation ns={uid}>{(t) => t("details")}</Translation>
                            </h3>
                        </ModalHeader>
                        <ModalBody>{state_unitDetails ? <UnitView unitType={state_unitDetails.unitType} data={JSON.parse(state_unitDetails.data)} width={450} height={680} /> : null}</ModalBody>
                    </Modal>
                </div>
            ) : null}
            {audioPath ? (
                <div style={{ margin: `20px auto`, textAlign: "center" }}>
                    <UnitTopAudioPlayer src={audioPath} />
                </div>
            ) : null}
            {imagePath ? (
                <div style={{ margin: `20px auto` }}>
                    <img style={{ width: "100%" }} src={Helper.convertToFileServerPath(imagePath)} />
                </div>
            ) : null}
        </>
    );
}

GeneralArticle.defaultProps = {
    showTitle: false, // do not show title by default?
}
